import { API } from "API/API";
import { Constants } from "constants/constants";

async function getSettings() {
  const settings_response = await API.get.wp("settings/get", null, {
    next: {
      tags: ["everything", "settings"],
    },
  });

  return settings_response?.data || {};
}

async function getAllSlugsCat() {
  const cats_response = await API.get.wp("settings/category_slugs", null, {
    next: {
      tags: ["everything", "categories", "all_cats"],
    },
  });

  return cats_response?.data || [];
}

async function getAllSlugsProd() {
  const products_response = await API.get.wp("settings/product_slugs", null, {
    next: {
      tags: ["everything", "products", "all_products"],
    },
  });

  return products_response?.data || [];
}

async function getAssortmentMenu() {
  const settings_response = await API.get.main_wp("settings/get_assortment_menu", null, {
    next: {
      tags: ["everything", "settings"],
    },
  });

  return settings_response?.data || {};
}

export const settings = {
  get: getSettings,
  get_assortment_menu: getAssortmentMenu,
  get_all_slugs_cat: getAllSlugsCat,
  get_all_slugs_prod: getAllSlugsProd,
};
